import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

interface RemoveServicesProps {
  open: boolean;
  services: String[];
  onRemove: () => void;
}

export const RemoveServices: React.FC<RemoveServicesProps> = ({
  open,
  services,
  onRemove,
}) => {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{ fontSize: "16px", color: "red", fontWeight: "normal !important" }}
      >
        Services Unavailable!
      </DialogTitle>

      <DialogContent sx={{ fontSize: "14px" }}>
        {services.join(", ")} service&#39;s unavailable at your area.
      </DialogContent>

      <DialogActions sx={{ padding: "16px" }}>
        <Button
          onClick={onRemove}
          fullWidth
          variant="contained"
          color="error"
          sx={{
            color: "red",
            borderColor: "#cccaca",
            backgroundColor: "#f2c2c2",
            width: "fit-content",
            borderRadius: "5rem",
            fontSize: "14px",
            "&:hover": {
              backgroundColor: "#f2c2c2",
            },
          }}
        >
          Remove From Cart
        </Button>
      </DialogActions>
    </Dialog>
  );
};
